import { FC, useEffect, useState } from "react";
import { UnifiedLoading } from "src/app/components/loading";
import "../../styles/css/requestnotification.css";
import "../../styles/css/select.css";

import SearchFirebase from "./playgrounds/searchFirebase";
import UserTab from "./playgrounds/user";
import ProcessTab from "./playgrounds/process";
import SetupCampaignTab from "./playgrounds/setupCampaign";
import TargetTab from "./playgrounds/target";
import MarketplaceCategoryTab from "./playgrounds/marketplaceCategory";
import StorefrontTab from "./playgrounds/storefront";
import FBEmbeddedSignupTab from "./playgrounds/fbEmbeddedSignup";
import OrdersTab from "./playgrounds/orders";
import ProductTab from "./playgrounds/product";
import RealtimeDBTab from "./playgrounds/realtimeDB";

const Playground: FC = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onBackClicked = () => {
    console.log("back clicked " + currentStep);

    if (currentStep === 1) {
      console.log("First Step Page");
      //
    } else {
      setCurrentStep(currentStep - 1);
      document.getElementById(`step_${currentStep}`)?.click();
    }
    console.log("Prev Step: " + currentStep);
  };

  const onContinueClicked = () => {
    console.log("continue clicked, current: " + currentStep);

    if (currentStep === 4) {
      console.log("Last Step Page");
      //
    } else {
      setCurrentStep(currentStep + 1);
      document.getElementById(`step_${currentStep}`)?.click();
    }
    console.log("Next Step: " + currentStep);
  };

  useEffect(() => {
    document.getElementById(`step_${currentStep}`)?.click();
  }, [currentStep]);

  return (
    <>
      {/* Create Campaign Step */}
      <div className="card mb-1 mb-xl-2 p-3">
        <div>
          {/* Step Tab */}
          <ul className="nav nav-tabs nav-line-tabs mb-5 fs-6">
            <li className="nav-item">
              <a
                className="nav-link active"
                data-bs-toggle="tab"
                href="#kt_tab_pane_1"
                id="step_1"
              >
                Setup Campaign
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_2"
                id="step_2"
              >
                Search Firebase
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_3"
                id="step_3"
              >
                Target
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_4"
                id="step_4"
              >
                User
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_5"
                id="step_5"
              >
                Setup Marketplace Product Category
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_7"
                id="step_7"
              >
                Setup Storefront List & Search Brand
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_9"
                id="step_9"
              >
                FB EMBEDDED SIGNUP
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_13"
                id="step_13"
              >
                Orders
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_14"
                id="step_14"
              >
                Product
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_15"
                id="step_15"
              >
                Process
              </a>
            </li>
            <li className="nav-item">
              <a
                className="nav-link"
                data-bs-toggle="tab"
                href="#kt_tab_pane_16"
                id="step_16"
              >
                Realtime DB
              </a>
            </li>
          </ul>
          {/* Step Details */}
          <div className="tab-content" id="myTabContent">
            {/* Step 1 */}
            <div className="tab-pane fade" id="kt_tab_pane_1" role="tabpanel">
              <SetupCampaignTab />
            </div>
            {/* Step 2 */}
            <div className="tab-pane fade" id="kt_tab_pane_2" role="tabpanel">
              <SearchFirebase />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_3" role="tabpanel">
              <TargetTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_4" role="tabpanel">
              <UserTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_5" role="tabpanel">
              <MarketplaceCategoryTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_7" role="tabpanel">
              <StorefrontTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_9" role="tabpanel">
              <FBEmbeddedSignupTab />
            </div>

            <div className="tab-pane fade" id="kt_tab_pane_13" role="tabpanel">
              <OrdersTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_14" role="tabpanel">
              <ProductTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_15" role="tabpanel">
              <ProcessTab />
            </div>
            <div className="tab-pane fade" id="kt_tab_pane_16" role="tabpanel">
              <RealtimeDBTab />
            </div>
          </div>
        </div>
        <div className="d-flex space mb-5 mt-10">
          <button
            type="button"
            className="btn btn-primary"
            onClick={onBackClicked}
          >
            Back
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={onContinueClicked}
          >
            Continue
          </button>
        </div>
      </div>
      <div></div>
      {isLoading && <UnifiedLoading />}
    </>
  );
};

export { Playground };
